// extracted by mini-css-extract-plugin
module.exports = {"select":"_2ygXdw057B1bnn0Zi6CKqD"};